import { useState } from "react";
import SupportTeamOnboardingModal from "./SupportTeamOnboardingModal";
import { useHistory } from "react-router-dom";

export default function GroupLeaderTips() {
  const [showModal, setShowModal] = useState(true);
  const history = useHistory();

  const handleModalClose = () => {
    setShowModal(false);
    history.push(`${process.env.PUBLIC_URL}/groupleader/groupleaderdashboard`);
  };

  const handleFinish = () => {
    setShowModal(false);
    history.push(`${process.env.PUBLIC_URL}/groupleader/groupleaderdashboard`);
  };

  return (
    <div className="container p-0">
      <SupportTeamOnboardingModal
        show={showModal}
        onHide={handleModalClose}
        onFinish={handleFinish}
      />
    </div>
  );
}
